import type { GetEntitiesRequest } from '@backstage/catalog-client';
import type { Entity } from '@backstage/catalog-model';
import type { TypedGetEntitiesRequest } from '@ipen-portal/plugin-common';

import { useApi } from '@backstage/frontend-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useQuery } from '@tanstack/react-query';

export const useGetEntitiesByFilter = <T extends Entity>(
  request?: null | TypedGetEntitiesRequest<T>,
  options?: {
    retry?: boolean | number;
    skip?: boolean;
  },
) => {
  const catalogApi = useApi(catalogApiRef);
  const { predicate, ...params } = request ?? {};

  return useQuery({
    enabled: !!request && !options?.skip,
    gcTime: 1000 * 60 * 5,
    queryFn: async () => {
      const { items } = await catalogApi.getEntities({
        ...params as GetEntitiesRequest,
        order: request?.order ?? [{ field: 'metadata.name', order: 'asc' }],
      });
      return items;
    },
    queryKey: ['catalog', 'entities', params],
    retry: options?.retry,
    select: (entities): T[] =>
      (predicate ? entities.filter(predicate) : (entities as T[])),
    staleTime: 1000 * 60 * 5,
  });
};
